import React, { useState } from "react";
import TagsAddApp from "./TagsAddApp";
import Button from "../UIcomponents/Button/Button";
import { ReactComponent as Plus } from "./static/plus-plate.svg";

export default function TagsAddFunction() {
    const [isOpen, setIsOpen] = useState(false);
    const stylesBtn = {
        display: 'flex',
        gap: '5px',
        alignItems: 'center',
    }
    const updateData = (value) => {
        setIsOpen(value)
    }
        return(
            <React.Fragment>
                
                {isOpen ?
                    <div>
                        <TagsAddApp setIsOpen={setIsOpen} updateData={updateData}></TagsAddApp>
                    </div>
                    :
                    <Button stylesContainer={stylesBtn} logo={<Plus width={'16px'} height={'16px'}/>} onClickFunc={() => setIsOpen(!isOpen)} btnType="filled" title="Добавить метку"/>
                    // <button className="d-flex button-add-tags" onClick={() => setIsOpen(true)}><p className="plus-add" /> Добавить метку</button>
                }
                
            </React.Fragment>
        )
    }
